import Vue from 'vue'
import { platformMutations } from '~/helpers/store'
import { CONSTANTS } from '@sohohouse/platform-resources'

export default {
  ...platformMutations,
  saveSearch: (s, { type, bookings }) => {
    const bookingIds = bookings.data.map(b => b.id)
    const cached = s.cached[type] ? s.cached[type].data : []
    const data = s.cached[type] ? [...new Set([...cached, ...bookingIds])] : bookingIds
    const meta = bookings.meta
    Vue.set(s.cached, type, { data, meta })
  },
  clearSearchById: (s, { id, type }) => {
    const cachedType = s.cached[type]
    const stateData = s.data
    if (cachedType) {
      const pos = cachedType.data.indexOf(id)

      cachedType.data.splice(pos, 1)

      Vue.set(s.cached, type, cachedType)
    }
    delete stateData[id]
    Vue.set(s, 'data', stateData)
  },
  fetchingByType: (s, type) => {
    const { EVENT_TYPES } = CONSTANTS
    switch (type) {
      case EVENT_TYPES.MEMBER_EVENT:
        s.meta.membersEventFetched = false
        s.meta.membersEventFetching = true
        break
      case EVENT_TYPES.INDUCTION:
        s.meta.inductionFetched = false
        s.meta.inductionFetching = true
        break
      case EVENT_TYPES.SCREENING:
        s.meta.screeningFetched = false
        s.meta.screeningFetching = true
        break
      default:
        s.meta.fitnessFetched = false
        s.meta.fitnessFetching = true
    }
  },
  fetchedByType: (s, type) => {
    const { EVENT_TYPES } = CONSTANTS
    switch (type) {
      case EVENT_TYPES.MEMBER_EVENT:
        s.meta.membersEventFetched = true
        s.meta.membersEventFetching = false
        break
      case EVENT_TYPES.INDUCTION:
        s.meta.inductionFetched = true
        s.meta.inductionFetching = false
        break
      case EVENT_TYPES.SCREENING:
        s.meta.screeningFetched = true
        s.meta.screeningFetching = false
        break
      default:
        s.meta.fitnessFetched = true
        s.meta.fitnessFetching = false
    }
  }
}
